"use strict";

import Page from "./Schedule.jsx";

export const auth = true;
export const title = "i18n:schedule.pageTitle";

export const Component = Page;
